<template>
  <div class="live-order">
    <div class="box">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadmore">
        <order-item v-for="item in orderList" :item="item" :key="item.id"></order-item>
      </van-list>
    </div>

    <div class="f v fvc btn-box">
      <div class="back-btn" @click="backHome">返回首页</div>
    </div>
  </div>
</template>

<script>
import orderItem from "./../../components/order-item";
export default {
  components: {
    orderItem,
  },
  data() {
    return {
      currentPage: 1,
      finished: false,
      loading: false,
      orderList: [],
    };
  },
  created() {
    this.getMyLiveOrder();
  },
  methods: {
    loadmore() {
      if (!this.finished) {
        this.currentPage++;
        this.getMyLiveOrder();
      }
    },
    getMyLiveOrder() {
      this.$http
        .post("/v1/orders/query_my_live", {
          page: this.currentPage,
          size: 10,
        })
        .then((res) => {
          this.loading = false;
          if (res.code === 10200) {
            this.finished = true;
          } else {
            this.orderList = this.orderList.concat(res.data.list);
          }
        });
    },
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.live-order {
  height: 100vh;
  background: #f5f6f7;
  .box {
    overflow: scroll;
    height: calc(100vh - 74px);
  }
  .back-btn {
    width: 133px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 15px;
  }
}
</style>